import React from 'react';

export const PayBill = () => {
    return (
        <section className="pay-bill newClass">
            <div id="btnPayFrm">
                <a href='https://fireflypediatric.securepayments.cardpointe.com/pay?' class="btn btn--pay">Pay Now</a>
                <div class="cards cards--s">
                    <img src='https://fireflypediatric.securepayments.cardpointe.com/admin/hpp/img/cc--visa.png' alt="" />
                    <img src='https://fireflypediatric.securepayments.cardpointe.com/admin/hpp/img/cc--mastercard.png' alt="" />
                    <img src='https://fireflypediatric.securepayments.cardpointe.com/admin/hpp/img/cc--discover.png' alt="" />
                </div>
            </div>
            <link href='https://fonts.googleapis.com/css?family=Raleway:300,400,500,600,700,800|Material+Icons' rel="stylesheet" type="text/css" id="customFont" />
        </section>
    )
}



// WEBPACK FOOTER //
// ./src/components/pay-bill/pay-bill.jsx